import { defineMessages } from "react-intl";

export const messages = defineMessages({
    migrationStatusTableSourceColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.source-column-title",
        defaultMessage: "Source",
        description:
            "Column title for the source column in the migration status table"
    },
    migrationStatusTableDestinationColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.destination-column-title",
        defaultMessage: "Destination",
        description:
            "Column title for the destination column in the migration status table"
    },
    migrationStatusTablePhaseColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.Phase-column-title",
        defaultMessage: "Phase",
        description:
            "Column title for the Phase column in the migration status table"
    },
    migrationStatusTableStatusColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.status-column-title",
        defaultMessage: "Status",
        description:
            "Column title for the status column in the migration status table"
    },
    migrationStatusTableTicketColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.ticket-column-title",
        defaultMessage: "Ticket",
        description:
            "Column title for the ticket column in the migration status table"
    },
    migrationStatusTablePlanToMigrateDateColumnTitle: {
        id: "fastshift.dashboard.migration-status-table.plan-to-migrate-date-column-title",
        defaultMessage: "Plan to migrate date",
        description:
            "Column title for the plan to migrate date column in the migration status table"
    },
    migrationStatusTableSourceDestinationColumnContentDefault: {
        id: "fastshift.dashboard.migration-status-table.source-column-content-default",
        defaultMessage: "Atlassian product",
        description:
            "Column content for the source column and destination column in the migration status table when the product is unknown"
    },
    migrationStatusTableSourceDestinationColumnContentNoBaseUrl: {
        id: "fastshift.dashboard.migration-status-table.source-column-content-no-base-url",
        defaultMessage: "url not available",
        description:
            "Column content for the source column and destination column in the migration status table when the source base URL is not available"
    },
    migrationStatusTablePlanToMigrateDateColumnContentDefault: {
        id: "fastshift.dashboard.migration-status-table.plan-to-migrate-date-column-content-default",
        defaultMessage: "Pending",
        description:
            "Column content for the plan to migrate date column in the migration status table when the date is not available"
    },
    migrationStatusTableJiraProductName: {
        id: "fastshift.dashboard.migration-status-table.jira-product-name",
        defaultMessage: "Jira",
        description:
            "Column content for the Jira product name in the migration status table"
    },
    migrationStatusTableConfluenceProductName: {
        id: "fastshift.dashboard.migration-status-table.confluence-product-name",
        defaultMessage: "Confluence",
        description:
            "Column content for the Confluence product name in the migration status table"
    }
});
